import { axiosInstances, getAxiosHeaders } from './config/axios';
import { routes } from './config/routes';

export const getTxHistory = async (params: any) => {
  try {
    let str = '';
    Object.keys(params).forEach((key) => {
      if (!str) {
        str += '?' + key + '=' + params[key];
      } else {
        str += `&${key}=${params[key]}`;
      }
    });
    const res = await axiosInstances.verificationV1?.get(
      `${routes.transactions.getTxHistory + str}`,
      getAxiosHeaders()
    );
    return res?.data;
  } catch {}
};

export const getPaymentRegionList = async (orgId: string) => {
  try {
    const res = await axiosInstances.payment?.get(
      `${routes.transactions?.getPaymentRegionList}?orgId=${orgId}`,
      getAxiosHeaders()
    );
    return res?.data;
  } catch {}
};

export const getPaidTxDetails = async (orgId: string, txnId: string, orderId: string) => {
  try {
    const response: any = await axiosInstances.verificationV1?.get(
      `${routes.transactions.getPaidTxDetails}/${orderId}/price?orgId=${orgId}&txnId=${txnId}`,
      getAxiosHeaders()
    );
    // return mockResponses.getPaymentStatus
    return response.data;
  } catch (e) {
    console.info(e);
    return false;
    // return mockResponses.getPaymentStatus
  }
};

export const getTxInfo = async (
  orgId: string,
  txnId: string,
  region: string | null,
  paymentId: string | null,
  express: boolean | null,
  phoneNumber: string | null
) => {
  try {
    const phoneNumberParam = phoneNumber ? `&phoneNumber=${encodeURIComponent(phoneNumber)}` : '';
    const expressString = express ? `&express=true${phoneNumberParam}` : '';
    let params = '';
    if (region) {
      if (import.meta.env.VITE_TEST && region === 'india') {
        params += '&region=test';
      } else {
        params += '&region=' + region;
      }
    }
    if (paymentId) {
      params += '&paymentId=' + paymentId;
    }
    const response: any = await axiosInstances.payment?.get(
      `${routes.transactions.getTxInfo}?orgId=${orgId}&txnId=${txnId}${params}${expressString}`,
      getAxiosHeaders()
    );

    // return mockResponses.getTxInfo
    return response.data;
  } catch (e) {
    console.info(e);
    return false;
    // return mockResponses.getTxInfo
  }
};

export const getPaymentStatus = async ({
  orgId,
  paymentId
}: {
  orgId: string,
  paymentId?: string | null
}) => {
  try {
    const response: any = await axiosInstances.payment?.get(
      `${routes.transactions.getPaymentStatus}?orgId=${orgId}${paymentId ? `&paymentId=${paymentId}` : ''}`,
      getAxiosHeaders()
    );
    // return mockResponses.getPaymentStatus
    return {
      data: response.data,
      error: false
    };
  } catch (e: any) {
    return {
      message: e.toString(),
      error: true
    };
    // return mockResponses.getPaymentStatus
  }
};

export const initPayment = async (
  orgId: string,
  txnId: string,
  region: string,
  express: string | null,
  phoneNumber: string | null
) => {
  try {
    const response: any = await axiosInstances.payment?.post(
      routes.transactions.initPayment,
      {
        orgId,
        txnId,
        region,
        express,
        phoneNumber
      },
      getAxiosHeaders()
    );
    // return mockResponses.initPayment
    return {
      data: response.data,
      error: false
    };
  } catch {
    return {
      error: true,
      message: 'Error in payment'
    };
    // return mockResponses.initPayment
  }
};

export const getPaymentMode = async (orgId: string, txnId: string | null) => {
  try {
    const response: any = await axiosInstances.payment?.get(
      `${routes.transactions.getPaymentMode}?txnId=${txnId}&orgId=${orgId}`,
      getAxiosHeaders()
    );
    // return mockResponses.getPaymentStatus
    return {
      data: response.data,
      error: false
    };
  } catch (e: any) {
    return {
      message: e.toString(),
      error: true
    };
    // return mockResponses.getPaymentStatus
  }
};
